//@flow
import React from "react";

export function ButtonCreativeGlass() {
  return (
    <button
      className="creative-glass"
      onClick={() => (window.location.href = "/creative-glass/")}
    >
      Check Availability (Creative Glass)
    </button>
  );
}
